<main class="bg-white position-relative">
  <div class="product-slider-sec ">
    <div class="banner-top-sec owl-carousel owl-theme">
      <div class="item">
        <section class="position-relative overflow-hidden" id="payoutt_top_sec">
          <div class="payoutt_container">
            <div class="container py-lg-5">
              <div class="row align-items-center">
                <div class="nike_logo col-12 position-absolute nike-shap-sec">
                  <img alt="" class="img-fluid" src="/assets/images/nike_logo.png"/>
                </div>
                <div class="col-md-6">
                  <div class="nike_product_slide">
                    <div class="nike_shoes position-absolute">
                      <img alt="" class="img-fluid" src="/assets/images/nike_shoes.png"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="title_content">
                    <h5 class="text-uppercase text-white oswald_font font_50 bold_300">QuickKicks
                      Marketplace</h5>
                    <h1 class="text-uppercase text-white open_sans font_68 bold_800">Verified
                      Sneakers</h1>
                    <div class="mt-lg-3 mt-xl-4">
                      <a
                        class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_20 mt-lg-2 mt-xl-4"
                        routerLink="/categories-detail">Shop
                        Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="item">
        <section class="position-relative overflow-hidden" id="payoutt_top_sec1">
          <div class="payoutt_container">
            <div class="container py-lg-5">
              <div class="row align-items-center">
                <div class="nike_logo col-12 position-absolute nike-shap-sec">
                  <img alt="" class="img-fluid" src="/assets/images/nike_logo.png"/>
                </div>
                <div class="col-md-6">
                  <div class="nike_product_slide">
                    <div class="nike_shoes position-absolute">
                      <img alt="" class="img-fluid" src="/assets/images/nike_shoes.png"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="title_content">
                    <h5 class="text-uppercase text-white oswald_font font_50 bold_300">QuickKicks
                      Marketplace</h5>
                    <h1 class="text-uppercase text-white open_sans font_68 bold_800">Verified
                      Sneakers</h1>
                    <div class="mt-lg-3 mt-xl-4">
                      <a
                        class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_20 mt-lg-2 mt-xl-4"
                        routerLink="/categories-detail">Shop
                        Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="item">
        <section class="position-relative overflow-hidden" id="payoutt_top_sec2">
          <div class="payoutt_container">
            <div class="container py-lg-5">
              <div class="row align-items-center">
                <div class="nike_logo col-12 position-absolute nike-shap-sec">
                  <img alt="" class="img-fluid" src="/assets/images/nike_logo.png"/>
                </div>
                <div class="col-md-6">
                  <div class="nike_product_slide">
                    <!-- <div class="nike_shoes position-absolute">
                      <img alt="" class="img-fluid" src="/assets/images/nike_shoes.png"/>
                    </div> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="title_content">
                    <h5 class="text-uppercase text-white oswald_font font_50 bold_300">QuickKicks
                      Marketplace</h5>
                    <h1 class="text-uppercase text-white open_sans font_68 bold_800">Verified
                      Sneakers</h1>
                    <div class="mt-lg-3 mt-xl-4">
                      <a
                        class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_20 mt-lg-2 mt-xl-4"
                        routerLink="/categories-detail">Shop
                        Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <!-- top_selling_sec -->
  <section class="position-relative overflow-hidden" id="top_selling_sec">
    <div class="top_selling_container pt-md-5 mt-md-2 mt-xl-4 mt-5 pt-2">
      <div class="container product-slider-sec">
        <div class="row align-items-center">
          <div class="col-md-7 col-7">
            <div class="main_def_title">
              <h2 class="text-uppercase text-dark oswald_font font_30 bold_600">Top selling</h2>
            </div>
          </div>
          <div class="col-md-5 col-5">
            <div class="right_smll_text text-right">
              <h6><a class="open_sans bold_700 text-green text-right font_16 see-all-btn"
                     routerLink="/categories-detail">See All <i
                aria-hidden="true" class="fa fa-angle-right font_20"></i></a></h6>
            </div>
          </div>
        </div>
        <div class="top_selling_slider_main mt-4 pt-2">
          <div class="top_selling_slider owl-carousel owl-theme">
            <div class="item">
              <div class="top_selling_product_box">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div
                    class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                    <span class="text-uppercase open_sans bold_700 font_20">April 18</span>
                  </div>
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_1.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low-The Ten</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
                <div
                  class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                  <a
                    class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Bid</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Buy
                    Now</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Sell</a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="top_selling_product_box">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div
                    class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                    <span class="text-uppercase open_sans bold_700 font_20">April 16</span>
                  </div>
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_2.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low '07'-MoMA</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
                <div
                  class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                  <a
                    class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Bid</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Buy
                    Now</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Sell</a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="top_selling_product_box">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div
                    class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                    <span class="text-uppercase open_sans bold_700 font_20">April 17</span>
                  </div>
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Max 90-Desert Ore</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
                <div
                  class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                  <a
                    class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Bid</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Buy
                    Now</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Sell</a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="top_selling_product_box">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div
                    class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                    <span class="text-uppercase open_sans bold_700 font_20">April 18</span>
                  </div>
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low-The Ten</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
                <div
                  class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                  <a
                    class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Bid</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Buy
                    Now</a>
                  <a
                    class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                    href="javascript:void(0);">Sell</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- new_releases_selling_sec -->
  <section class="position-relative overflow-hidden" id="new_releases_sec">
    <div class="new new_releases_container pt-md-5 mt-md-4 pt-4 mt-3">
      <div class="container product-slider-sec">
        <div class="pt-md-5 border-top pt-4">
          <div class="row align-items-center pt-md-4 mt-3 mt-md-0">
            <div class="col-md-7 col-7">
              <div class="main_def_title">
                <h2 class="text-uppercase text-dark oswald_font font_30 bold_600">New Releases</h2>
              </div>
            </div>
            <div class="col-md-5 col-5">
              <div class="right_smll_text text-right">
                <h6><a class="open_sans bold_700 text-green text-right font_16 see-all-btn"
                       routerLink="/categories-detail">See All
                  <i aria-hidden="true" class="fa fa-angle-right font_20"></i></a></h6>
              </div>
            </div>
          </div>
          <div class="new_releases_slider_main mt-4 pt-2">
            <div class="top_selling_slider new_releases_slider owl-carousel owl-theme">
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div
                      class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                      <span class="text-uppercase open_sans bold_700 font_20">April 18</span>
                    </div>
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      6 Retro DMP (2020)</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div
                      class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                      <span class="text-uppercase open_sans bold_700 font_20">April 17</span>
                    </div>
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_2.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Linen</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div
                      class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                      <span class="text-uppercase open_sans bold_700 font_20">April 18</span>
                    </div>
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_3.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      1 Retro High Court Purple White</a></h3>
                    <h4 class="mt-2  oswald_font bold_600 font_20 text-dark">$200.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div
                      class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                      <span class="text-uppercase open_sans bold_700 font_20">April 18</span>
                    </div>
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      6 Retro DMP (2020)</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- featured_products_selling_sec -->
  <section class="position-relative overflow-hidden" id="featured_products_sec">
    <div class="new featured_products_container pt-md-5 mt-md-4 pt-4 mt-3">
      <div class="container product-slider-sec">
        <div class="pt-md-5 border-top pt-4">
          <div class="row align-items-center pt-md-4 mt-3 mt-md-0">
            <div class="col-md-7 col-8">
              <div class="main_def_title">
                <h2 class="text-uppercase text-dark oswald_font font_30 bold_600">Featured Products
                </h2>
              </div>
            </div>
            <div class="col-md-5 col-4">
              <div class="right_smll_text text-right">
                <h6><a class="open_sans bold_700 text-green text-right font_16 see-all-btn"
                       routerLink="/categories-detail">See All
                  <i aria-hidden="true" class="fa fa-angle-right font_20"></i></a></h6>
              </div>
            </div>
          </div>
          <div class="featured_products_slider_main mt-4 pt-2">
            <div class="top_selling_slider featured_products_slider owl-carousel owl-theme">
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Cinder</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$255.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_2.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Zebra</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_3.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      1 Retro High Court Purple White</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="top_selling_product_box">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Cinder</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$255.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <div
                    class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                    <a
                      class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Bid</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Buy
                      Now</a>
                    <a
                      class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                      href="javascript:void(0);">Sell</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Buy And Sell Sec -->
  <section class="position-relative" id="buy_and_sell_sec">
    <div class="buy_and_sell_container pt-md-5">
      <div class="container">
        <div class="row align-items-center h-100">
          <div class="col-md-6 col-12 h-100 d-table-cell w-50">
            <div class="bg-white buy_sell_box px-md-4 py-md-4 px-xl-5 py-xl-5 h-100">
              <div class="media">
                <div class="multi_icon multi_icon_1">
                  <div class="multi_icon_inner multi_icon_inner_1"></div>
                </div>
                <div
                  class="media-body ml-md-2 ml-xl-4 pl-md-3 payouttt_offers_content payouttt_offers_content_1">
                  <h3 class="open_sans bold_700 font_30 text-uppercase text-dark">Buy</h3>
                  <p class="mt-2 font_18 open_sans bold_400">QuickKicks offers the most competitive
                    pricing for the hottest releases. Browse thousands of limited sneakers on
                    the marketplace. Place a bid or <br> buy now!</p>
                  <div class="mt-md-1 mt-xl-2">
                    <a
                      class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_26 mt-md-2 mt-xl-4"
                      routerLink="/buy-now">Buy
                      Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12 h-100 d-table-cell w-50 mt-3 mt-md-0">
            <div class="bg-white buy_sell_box px-md-4 py-md-4 px-xl-5 py-xl-5 h-100">
              <div class="media">
                <div class="multi_icon multi_icon_2">
                  <div class="multi_icon_inner multi_icon_inner_2"></div>
                </div>
                <div
                  class="media-body ml-md-2 ml-xl-4 pl-md-3 payouttt_offers_content payouttt_offers_content_2">
                  <h3 class="open_sans bold_700 font_30 text-uppercase text-dark">Sell</h3>
                  <p class="mt-2 font_18 open_sans bold_400">QuickKicks guarantees the lowest seller
                    fees available on the marketplace. Offering top notch security and the best
                    tools for selling. Use the app today to become a verified seller!</p>
                  <div class="mt-md-1 mt-xl-2">
                    <a
                      class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-md-2 mt-xl-4"
                      routerLink="/sell-now">Sell
                      Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Download the QuickKicks App -->
  <section class="position-relative overflow-hidden pt-md-5" id="download_payouttt_sec">
    <div class="download_payouttt_container pt-md-5 mt-md-4 pb-md-5" data-height="508" data-width="3000">
      <div class="container pb-md-3 pt-xl-2">
        <div class="row">
          <div class="col-md-5 offset-lg-1 order-2 order-md-0">
            <div class="download-payoutt">
              <h3 class="text-left oswald_font bold_600 font_44 text-uppercase" style="color:#272727">Download
                the QuickKicks App</h3>
              <div class="rating_list mt-sm-3">
                                    <span class="pl-0"><i aria-hidden="true"
                                                          class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-2 open_sans bold_600 font_18" style="color:#272727">4.9</span>
              </div>
              <div class="app_list mt-md-4 mt-xl-4 pt-xl-2">
                <ul class="pl-0 mb-0">
                  <li
                    class="open_sans bold_600 font_18 position-relative pl-2 pl-sm-4 mb-1 mb-xl-2 mb-lg-0" style="color:#272727">
                    Shop the latest releases
                  </li>
                  <li
                    class="open_sans bold_600 font_18 position-relative pl-2 pl-sm-4 mb-1 mb-xl-2 mb-lg-0" style="color:#272727">
                    Manage your most-wanted styles
                  </li>
                  <li
                    class="open_sans bold_600 font_18 position-relative pl-2 pl-sm-4 mb-1 mb-xl-2 mb-lg-0" style="color:#272727">
                    Get notifications on price drops
                  </li>
                </ul>
              </div>
              <div class="app_link_downloads d-flex align-items-center mt-md-5 mt-2">
                <a href="javascript:void(0);" target="_blank">
                  <img alt="" class="img-fluid" src="/assets/images/google_play.png"/>
                </a>
                <a class="ml-2" href="javascript:void(0);" target="_blank">
                  <img alt="" class="img-fluid" src="/assets/images/app_store.png"/>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="download_moile_screen position-absolute">
              <img alt="" class="img-fluid" src="/assets/images/download_moile_screen.png"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
